var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',{attrs:{"value":_vm.valueList,"disabled":_vm.disabled},on:{"input":_vm.change}},_vm._l((_vm.checkList),function(item){return _c('el-checkbox',{key:item.value,attrs:{"label":item.value}},[_vm._v(_vm._s(item.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }